module.exports = __webpack_public_path__ + "img/logo-800x800.ad8aa96c.png";